<template>
<v-select box multiple v-model="selectedDays" :items="weekdays" :label="$t('schedule.days')" :rules="rules" clearable></v-select>
</template>

<script>
export default {
  name: 'WeekdaySelector',
  props: {
    value: {
      type: Array
    }
  },
  data() {
    return {
      days: [
        'sunday',
        'monday',
        'tuesday',
        'wednesday',
        'thursday',
        'friday',
        'saturday',
      ],
      rules: [
        v => !!v || this.$t('schedule.days_required'),
        v => (v && v.length > 0) || this.$t('schedule.days_required')
      ]
    }
  },
  computed: {
    selectedDays: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', [...this.days].filter(d => val.includes(d)));
      }
    },
    weekdays() {
      return this.days.map((d, i) => ({
        text: this.$t(`schedule.${d}`),
        value: d
      }))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/schedule/WeekdaySelector.vue